import { createContext, useContext } from 'react';

import { type SpectrumWidgetRequest } from '$/services/usecases/materials';

export const SpectrumWidgetRequestContext = createContext<
  SpectrumWidgetRequest | undefined
>(undefined);

export const useSpectrumWidgetRequest = () =>
  useContext(SpectrumWidgetRequestContext);
